import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/auth/Login";
import AutoLogout from "./components/AutoLogout";
import DisableUndoRedo from "./components/DisableUndoRedo";
import Dashboard from "./components/page/dashboard";
import ProtectedRoute from "./ProtectedRoute";
import ExchnageApi from "./components/page/ExchnageApi.js/Index";
import Invest from "./components/page/Invest";

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable F12, Ctrl+Shift+I/J/C, Ctrl+U
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          ["I", "J", "C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === "U")
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Detect DevTools open (console trick)
    const devToolsDetector = () => {
      const element = new Image();
      Object.defineProperty(element, "id", {
        get: function () {
          // Detected!
          window.location.href = "about:blank"; // or show alert/log
        },
      });
    };
    devToolsDetector();

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return (
    <div>
      <Router>
        <AutoLogout />
        <DisableUndoRedo />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute component={<Dashboard />} />}
          />
            <Route
            path="/exchange-api"
            element={<ProtectedRoute component={<ExchnageApi />} />}
          />
          <Route path="/invest/:id" element={<ProtectedRoute component={<Invest />} />}/>
        </Routes>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
